import { render, staticRenderFns } from "./loading_desktop.vue?vue&type=template&id=33dc73a2&scoped=true&"
import script from "./loading_desktop.vue?vue&type=script&lang=js&"
export * from "./loading_desktop.vue?vue&type=script&lang=js&"
import style0 from "./loading_desktop.vue?vue&type=style&index=0&id=33dc73a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc73a2",
  null
  
)

export default component.exports